export default "__VITE_ASSET__D7noMvt0__"